import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import TextCropper from '@omilia/text-cropper';

import useAppResizeObserver from 'utils/hooks/useAppResizeObserver';
import { utteranceType } from 'types';
import TrashTooltip from 'components/TrashTooltip';

import './style.scss';

function useDebouncedIncrease(initialState) {
  const [value, update] = React.useState(initialState);
  const debouncedUpdate = debounce(() => update(x => x + 1), 50);
  const increase = React.useCallback(debouncedUpdate, [update]);

  return [value, increase];
}

function UtteranceItem({ index, utterance, onDelete }) {
  const [value, increase] = useDebouncedIncrease(0);
  useAppResizeObserver(increase);

  return (
    <div styleName="item">
      <span styleName="number">{index + 1}.</span>
      <div styleName="box">
        <span styleName="name">
          <TextCropper key={index + 1 + value} text={utterance.utterance} />
        </span>
        <TrashTooltip
          text="Delete utterance"
          onDelete={() => onDelete(index)}
        />
      </div>
    </div>
  );
}

UtteranceItem.propTypes = {
  index: PropTypes.number.isRequired,
  utterance: utteranceType.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default UtteranceItem;
